import { css } from 'styled-components';

import { Colour } from '@xemplo/colours';
import { zIndex } from '@xemplo/zindex';

import { MinBreakpointV2 } from './media-query-v2';

export const Overlay = css`
  position: fixed;
  inset: 0;
  z-index: ${zIndex.ModalOverlay};
  background-color: ${Colour.Gray[900]};
  opacity: 0.6;

  @media ${MinBreakpointV2.medium} {
    display: none;
  }
`;
/** Icon stroke width values (px) */
export const SvgStroke = {
  Light: 1,
  Regular: 1.5,
  Bold: 2,
  ExtraBold: 2.5,
  ExtraHeavy: 3,
  Ultra: 3.5,
} as const;
